var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.popupOfferV2 = {
  // Inline template name that is grabbed and shown in pop-up.
    templateName: 'popup_offer_v2',

    // Class name to be used for colorbox popup launch.
    colorBoxClassName: 'js-popup-offer-overlay-cbox-v2 popup-offer-v2 popup-offer-cbox popup-offer-overlay-cbox',

    // Cookie keeps count of pages viewed
    cookieName: 'popup_offer_values',
    // Cookie expires multiple times per day
    sessionCookieName: 'popup_offer_values_session',

    // The four larger elements that are displayed at different
    // stages of the popup process.
    popupElements: {
      first: '.js-popup-offer-outer-wrap',
      thankYou: '.js-popup-offer-thank-you',
      signedUp: '.js-popup-offer-signed-up',
      terms: '.js-popup-offer-terms',
      policy: '.js-popup-offer-policy'
    },

    // Track whether or not the .js-popup-offer-terms element is showing.
    termsShowing: false,
    policyShowing: false,

    // Store which div class was showing when the terms were opened.
    elementShowing: '',

    // Store the original colorbox close method.
    originalColorboxCloseMethod: $.colorbox.close,

    // Given the way the terms & conditions are shown in the colorbox overlay,
    // the close function must be overwritten a bit:
    // If the flag for termsShowing is true, just hide the terms, don't close the box.
    // Otherwise, act normally, by calling the original close method.
    overwriteColorboxClose: function (context) {
      var self = this;
      var $emailSkip = $('.js-mantle-cta-button', context);

      $.colorbox.close = function () {
        if (self.termsShowing) {
          self.hideTerms(context);
        } else if (self.policyShowing) {
          self.hidePolicy();
        } else {
          self.originalColorboxCloseMethod();
        }

        if ($emailSkip.length > 0) {
          $emailSkip.trigger('click');
        }
      };
    },
    // Show the terms element and store what was being shown previously.
    showTerms: function (context) {
      var self = this;

      $(self.popupElements.terms, context).show();
      $(self.popupElements.policy, context).hide();
      $(self.elementShowing, context).hide();
      self.termsShowing = true;
    },

    // Hide the .js-popup-offer-terms element and show previous element.
    hideTerms: function (context) {
      var self = this;

      $(self.popupElements.terms, context).hide();
      $(self.popupElements.policy, context).hide();
      $(self.elementShowing).show();
      self.termsShowing = false;
    },

    // Show the policy element and store what was being shown previously.
    showPolicy: function (context) {
      var self = this;

      $(self.popupElements.policy, context).show();
      $(self.popupElements.terms, context).hide();
      $(self.elementShowing).hide();
      self.policyShowing = true;
    },

    // Hide the .js-popup-offer-policy element and show previous element.
    hidePolicy: function (context) {
      var self = this;

      $(self.popupElements.policy, context).hide();
      $(self.popupElements.terms, context).hide();
      $(self.elementShowing).show();
      self.policyShowing = false;
    },

    // Make the RPC call for the email sign-up form in the pop-up.
    processForm: function (context) {
      var self = this;
      // Get all the fields in code because 'serialize' encodes bad emails and doesn't decode plus symbols.
      var formFields = [
        '_SUBMIT',
        'COUNTRY_ID',
        'LANGUAGE_ID',
        'PC_EMAIL_PROMOTIONS',
        'LAST_SOURCE',
        'ORIGINAL_SOURCE',
        'PC_EMAIL_ADDRESS',
        'BIRTH_MONTH',
        'BIRTH_DAY',
        'BIRTH_YEAR'
      ];
      // Create an object to hold all the parameters and their values.
      var paramObj = {};

      // Loop through each field and get its value.
      $.each(formFields, function (index, value) {
        var formField = $('.js-popup-offer-sign-up input[name=' + value + '], .js-popup-offer-sign-up select[name=' + value + ']', context);

        paramObj[value] = formField.val();
      });

      // microservice_api
      if (!Drupal.settings.use_jsonrpc) {
        generic.data.remove('UserId', 'session');
      }
      // Send the data via a JSON RPC call.
      generic.jsonrpc.fetch({
        apiFilterName: 'email-signup',
        method: 'rpc.form',
        params: [paramObj],
        onSuccess: function (jsonRpcResponse) {
          var response = jsonRpcResponse.getData();

          if (Drupal.settings.use_jsonrpc) {
          // Store returned boolean value for whether the user has already opted in the promotion before.
            var previouslyOptedInEmailPromotion = response.userinfo.previously_opted_in_email_promotion;
            // Store return boolean for still running the special offer codes.
            var specialOfferCodeStatus = response.userinfo.special_offer_code_status || 1;

            // If the user had not previously opted in AND the special offers are still running.
            if (!previouslyOptedInEmailPromotion && specialOfferCodeStatus) {
              $(self.popupElements.thankYou, context).show();
              self.elementShowing = self.popupElements.thankYou;
              // Else show that the user has already signed up for this offer.
            } else {
              $(self.popupElements.signedUp, context).show();
              self.elementShowing = self.popupElements.signedUp;
            }
          } else {
            if (!!response.uuid) {
              generic.data.set('UserId', response.uuid, { type: 'session' });

              // If the user has already signed up for this offer.  
              if ('initialOptIn' in response) {
                $(self.popupElements.signedUp, context).show();
                self.elementShowing = self.popupElements.signedUp;
              // Else show that the user has first time signed up for this offer.
              } else {
                $(self.popupElements.thankYou, context).show();
                self.elementShowing = self.popupElements.thankYou;
              }
            }
          }

          // Regardless, hide the original sign up form portion.
          $(self.popupElements.first, context).hide();
          $.colorbox.resize();
        },
        onFailure: function (jsonRpcResponse) {
        // Store messages and display them in error div element.
          var messages = jsonRpcResponse.getMessages();

          $('.js-popup-offer-error-messages', context).empty().removeClass('hidden');
          $('.js-popup-offer-sign-up', context).find('.error').removeClass('error');
          $.each(messages, function (index) {
            var errorInputfield = messages[index].tags[2].split('field.')[1];

            $('[name="' + errorInputfield.toUpperCase() + '"]', $('.js-popup-offer-sign-up'), context).addClass('error');
            $('.js-popup-offer-error-messages', context).append('<span>' + messages[index].text + '</span>');
          });
          $.colorbox.resize();
        }
      });
    },

    // Launch the popup window with the appropriate element visible.
    launchPopupWindow: function (context, elementToShow) {
      var self = this;
      var okayToLaunchPopup = true;
      // Get the popup template.
      var templateHTML = site.template.get({
        name: self.templateName
      });
      // Get value of data attribute 'enable-popup', it's should be either 'yes' or 'no'.
      var $templateContext = $(templateHTML);
      var enablePopup = $templateContext.data('enable-popup');

      if (typeof enablePopup === 'undefined') {
        enablePopup = 'yes';
      } // If not set, give it the value of 'yes'.

      // Set a default elementToShow just in case.
      if (elementToShow === undefined) {
        elementToShow = self.popupElements.first;
        // If there was no elementToShow parameter, then this was triggered by visiting some page, not triggered by an email signup.
        // Therefore, the value of enablePopup must be used to see if the popup should actually launch.
        if (enablePopup === 'no' || enablePopup === 'false' || !enablePopup) {
          okayToLaunchPopup = false;
        }
      }

      if (okayToLaunchPopup) {
      // When mobile, override any height/width and set to 100%
        if ($(window).width() <= 768) {
          $.colorbox({
            html: templateHTML,
            width: '320px',
            height: '325px',
            display: 'inline',
            trapFocus: false,
            className: self.colorBoxClassName
          });
          $('#cboxOverlay').hide();
        } else {
        // Launch the popup with colorbox.
          generic.overlay.launch({
            content: templateHTML,
            width: 511,
            height: 352,
            trapFocus: false,
            cssClass: self.colorBoxClassName
          });
          $('.js-popup-offer-overlay-cbox-v2 select', context).each(function () {
            $(this).selectBox();
          });
        }

        // Loop through all popupElements and only show the one specified
        // in the parameter elementToShow (or the default value).
        for (var elemKey in self.popupElements) {
          if (self.popupElements.hasOwnProperty(elemKey)) {
            var elemValue = self.popupElements[elemKey];

            if (elemValue === elementToShow) {
              $(elemValue).show();
              self.elementShowing = elemValue;
            } else {
              $(elemValue).hide();
            }
          }
        }
      }
    },

    bindEvents: function (context) {
      var self = this;

      $('.js-popup-offer-footer a', context).click(function (e) {
        e.preventDefault();
        self.showTerms(context);
      });
      $('.js-popup-offer-footer a.terms_link', context).click(function (e) {
        e.preventDefault();
        self.showTerms(context);
      });
      $('.js-popup-offer-footer a.policy_link', context).click(function (e) {
        e.preventDefault();
        self.showPolicy(context);
      });
      $('.js-popup-offer-terms-back', context).click(function (e) {
        e.preventDefault();
        self.hideTerms(context);
      });
      $('.js-popup-offer-policy-back', context).click(function (e) {
        e.preventDefault();
        self.hidePolicy(context);
      });
      $('.js-popup-offer-submit', context).click(function (e) {
        e.preventDefault();
        self.processForm(context);
      });
    },

    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var self = this;
      // Get the popup template.
      var templateHTML = site.template.get({
        name: self.templateName
      });
      // Get value of data attributes
      var $templateContext = $(templateHTML);
      var expiresPerDay = parseFloat(1 / $templateContext.data('times-per-day')); // Default 0.5 == twice per day
      var pageCount = parseInt($templateContext.data('page-count')); // Default 2
      // Count pages viewed per session
      var count = 0;
      // Default to 'yes'
      var cookieVal = 'yes';
      // Check for a value for the day long cookie & the session cookie
      var cookieValue = $.cookie(self.cookieName); // Can contain [count, 'yes']
      var hidePopupSessionCookie = $.cookie(self.sessionCookieName); // expires # times per day.
      var hidePopupCookie;

      $(document).on('email_signup:success_but_signed_up', function () {
        Drupal.behaviors.popupOfferV2.launchPopupWindow(context, '.js-popup-offer-signed-up');
        Drupal.behaviors.popupOfferV2.bindEvents(context);
      });

      $(document).on('email_signup:success_and_new', function () {
        Drupal.behaviors.popupOfferV2.launchPopupWindow(context, '.js-popup-offer-thank-you');
        Drupal.behaviors.popupOfferV2.bindEvents(context);
      });

      $(document).on('email_signup:launch', function () {
        Drupal.behaviors.popupOfferV2.launchPopupWindow(context);
        Drupal.behaviors.popupOfferV2.overwriteColorboxClose(context);
        Drupal.behaviors.popupOfferV2.bindEvents(context);
      });

      if (cookieValue != null) {
        try {
          hidePopupCookie = JSON.parse(cookieValue);
        } catch (err) {
          $.cookie(self.cookieName, null);
        }
      } else {
        hidePopupCookie = null;
      }

      var date;
      var minutes;
      var whenExpires;

      // If a returning visitor within same session
      if (hidePopupCookie != null && _.isArray(hidePopupCookie) && hidePopupSessionCookie != null) {
      // get values
        count = parseInt(hidePopupCookie[0]);
        cookieVal = hidePopupCookie[1];
        // increment page counter
        count++;
        // console.log({'count':count,'hidePopupCookie':hidePopupCookie,'hidePopupSessionCookie':hidePopupSessionCookie}); // DEBUG
        // update cookie
        $.cookie(self.cookieName, JSON.stringify([count, cookieVal]), { path: '/' });
      // console.log('returning visitor');
      } else {
        // New visitor or new session
        // Set new cookies
        count = 1;
        $.cookie(self.cookieName, JSON.stringify([count, cookieVal]), { path: '/' });
        date = new Date();
        minutes = expiresPerDay * 24 * 60;
        whenExpires = date.setTime(date.getTime() + (minutes * 60 * 1000));
        $.cookie(self.sessionCookieName, 'hidden', {
          expires: whenExpires,
          path: '/'
        });
        // console.log('new session visitor');
      }

      // Check page counter
      if (count === pageCount && cookieVal !== 'no') {
        // launch popup
        self.launchPopupWindow(context);
        self.overwriteColorboxClose(context);
        self.bindEvents(context);
        // deny further popups until session is reset
        cookieVal = 'no';
        // reset cookies
        count = 1;
        $.cookie(self.cookieName, JSON.stringify([count, cookieVal]), { path: '/' });
        date = new Date();
        minutes = expiresPerDay * 24 * 60;
        whenExpires = date.setTime(date.getTime() + (minutes * 60 * 1000));
        $.cookie(self.sessionCookieName, 'hidden', {
          expires: whenExpires,
          path: '/'
        });
        console.log('launch popup');
        $.colorbox.resize();
      }
    },
    attached: false
  };
})(jQuery);
